// IMPORTS
// Modules
import $ from 'jquery';
// Assets
import './../scss/OHSImages.scss';
import icon_pencil from './../icons/pencil_dark.svg';
import icon_trashcan from './../icons/trashcan_dark.svg';


// COMPONENT
export default function OHSImages (props) {
   // States and Variables
   const containerID = 'ohsimages-' + Math.floor(Math.random() * 999999);

   // Component
   return (
      <div id={props.id} className='ohsimages'>
         <div className='ohsimages-upload'>
            <p>Upload Images: </p>
            <input id={`${containerID}-upload-file`} type='file' className='ohsinput' />
            <button type="submit" className='ohsbtn' onClick={() => {props.upload(containerID + '-upload-file');}}>Upload</button>
         </div>
         <div className='ohsimages-list'>
            {props.images && props.images.length > 0 && props.images.map(function (image, i) {
               // Variables
               let inputID = containerID + "-edit-file-" + image.id;

               // Content
               return (
                  <div key={`ohsimages-list-item-${i}`} className='ohsimages-list-item'>
                     <div id={`${containerID}-list-item-image-${image.id}`} className='ohsimages-list-item-thumbnail'>
                        <img src={`/api/v1/oneport/files/${image.id}`} alt="Image" onClick={() => {$('#' + containerID + '-list-item-image-' + image.id).toggleClass('ohsimages-list-item-full');}} />
                     </div>
                     <div className='ohsimages-list-item-controls'>
                        <button className='ohsbtn' onClick={() => {document.getElementById(inputID).click();}}><img src={icon_pencil} alt="Pencil" /></button>
                        <button className='ohsbtn-error' onClick={() => {props.delete(image.id, i);}}><img src={icon_trashcan} alt="Trash Can" /></button>
                        <input id={inputID} type='file' className='ohsinput' onChange={() => {props.update(image.id, inputID);}} />
                     </div>
                  </div>
               );
            })}
         </div>
      </div>
   );
}